//
import { ModuleLayout } from '@/components/reusable_components/next'
import FamilyList from '@/views/Family/FamilyList'
import FamilyCreate from '@/views/Family/FamilyCreate'
import FamilyShowEdit from '@/views/Family/FamilyShowEdit'

import FamilyWholesaleDiscountsCreate from '@/views/Family/FamilyWholesaleDiscounts/FamilyWholesaleDiscountsCreate'
import FamilyWholesaleDiscountsShowEdit from '@/views/Family/FamilyWholesaleDiscounts/FamilyWholesaleDiscountsShowEdit'

import SubfamilyWholesaleDiscountsCreate from '@/views/Subfamily/SubfamilyWholesaleDiscounts/SubfamilyWholesaleDiscountsCreate'
import SubfamilyWholesaleDiscountsShowEdit from '@/views/Subfamily/SubfamilyWholesaleDiscounts/SubfamilyWholesaleDiscountsShowEdit'

import SubfamilyList from '@/views/Subfamily/SubfamilyList'
import SubfamilyCreate from '@/views/Subfamily/SubfamilyCreate'
import SubfamilyShowEdit from '@/views/Subfamily/SubfamilyShowEdit'

//
export default {
    path: 'families',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'families_list',
            component: FamilyList,
        },
        {
            path: 'create',
            name: 'families_create',
            component: FamilyCreate,
            meta: {
                title: 'Crear familia'
            },
        },
        {
            path: ':id',
            //name: 'FamilyShowEdit',
            component: ModuleLayout,
            children: [
                {
                    path: '',
                    name: 'FamilyShowEdit',
                    component: FamilyShowEdit,
                    meta: {
                        title: 'Detalle de subfamilias'
                    },
                },
                {
                    path: 'wholesale_discounts',
                    name: 'family_wholesale_discounts',
                    component: FamilyWholesaleDiscountsShowEdit,
                },
                {
                    path: 'wholesale_discounts/create',
                    name: 'family_wholesale_discounts_create',
                    component: FamilyWholesaleDiscountsCreate,
                },

                {
                    // paths relacionados con SUBFAMILIAS
                    path: 'subfamilies',
                    component: ModuleLayout,
                    children: [
                        {
                            path: '',
                            name: 'SubfamilyList',
                            component: SubfamilyList,
                        },
                        {
                            path: 'create',
                            name: 'SubfamilyCreate',
                            component: SubfamilyCreate,
                        },
                        {
                            path: ':id_subfamily',
                            name: 'Subfamily',
                            component: ModuleLayout,
                            children: [
                                {
                                    path: '',
                                    name: 'SubfamilyShowEdit',
                                    component: SubfamilyShowEdit,
                                },
                                {
                                    path: 'wholesale_discounts',
                                    name: 'subfamily_wholesale_discounts',
                                    component: SubfamilyWholesaleDiscountsShowEdit,
                                },
                                {
                                    path: 'wholesale_discounts/create',
                                    name: 'subfamily_wholesale_discounts_create',
                                    component: SubfamilyWholesaleDiscountsCreate,
                                },
                            ],
                            props: {
                                noContainer: true,
                            },
                        },
                    ],
                    props: {
                        noContainer: true,
                    },
                },
            ],
            props: {
                noContainer: true,
            },
        },
    ],
    props: {
        noContainer: true,
    },
    meta: {
        title: 'Familias'
    },
}
